import { render } from "./link-button.vue?vue&type=template&id=0ff9440d&ts=true"
import script from "./link-button.vue?vue&type=script&lang=ts"
export * from "./link-button.vue?vue&type=script&lang=ts"

import "./link-button.vue?vue&type=style&index=0&id=0ff9440d&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__